// @ts-nocheck

// App
import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useYieldCallback } from '@zillow/yield-callback';

// Actions
import AppActions from 'app/shared/flux/actions/AppActions';

// Components
import CreateSearchAlertModal from 'app/shared/modules/user-search/CreateSearchAlertModal';

// Misc / utils
import VALUE_CONSTANTS from 'app/shared/constants/ValueConstants';
import * as S from './styles';
import { emitTrackOpenSearchAlertModalEvent } from 'app/shared/models/Clickstream/SearchAlertEvents';

const AlertsButton = () => {
  // Redux
  const dispatch = useDispatch();
  const showCreateSearchAlert = useSelector((state) => state.app.overlays.createSearchAlert);

  const yieldToggleOverlay = useYieldCallback(({ toggleOverlay }) => {
    emitTrackOpenSearchAlertModalEvent();
    dispatch(AppActions.toggleOverlay('createSearchAlert', toggleOverlay));
  });

  const handleShowPopup = useCallback(() => {
    yieldToggleOverlay({ toggleOverlay: true });
  }, []);

  const handleAlertsButtonKeyDown = useCallback(
    (e) => {
      const keyCode = e.keyCode;

      if (keyCode === VALUE_CONSTANTS.ENTER_KEYCODE) {
        handleShowPopup();
      }
    },
    [handleShowPopup],
  );

  const handleHidePopup = useCallback(() => {
    yieldToggleOverlay({ toggleOverlay: false });
  }, []);

  return (
    <>
      <S.AlertsButton
        aria-label="Get search alerts based on your location and filter preferences"
        onClick={handleShowPopup}
        onKeyDown={handleAlertsButtonKeyDown}
      >
        Save search
      </S.AlertsButton>
      {showCreateSearchAlert && (
        <CreateSearchAlertModal
          onHidePopup={handleHidePopup}
          triggerLocation="search_results"
          triggerObject="search_results|alerts_modal"
        />
      )}
    </>
  );
};

export default AlertsButton;
